interface SearchableMenuItem {
  label: string;
  moduleName?: string;
  children?: SearchableMenuItem[];
}

interface SearchableMenuCategory {
  label: string;
  items: SearchableMenuItem[];
}

export function filterMenuCategories<T extends SearchableMenuCategory>(
  categories: T[],
  search: string,
): T[] {
  const query = search.trim().toLowerCase();
  if (!query) return categories;

  const filterItems = <I extends SearchableMenuItem>(items: I[]): I[] =>
    items.flatMap((item) => {
      if (
        item.label.toLowerCase().includes(query) ||
        item.moduleName?.toLowerCase().includes(query)
      ) return [item];

      const children = filterItems(item.children ?? []);
      return children.length ? [{ ...item, children }] : [];
    });

  return categories
    .map((category) => ({
      ...category,
      items: category.label.toLowerCase().includes(query)
        ? category.items
        : filterItems(category.items),
    }))
    .filter((category) => category.items.length > 0);
}
